var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"view"},[_c('div',{staticClass:"dashboard-wrapper"},[_c('div',{staticClass:"dashboard-actions"},[_c('Select',{attrs:{"name":"Dashboard","mode":"single","list":_vm.list,"selected":[_vm.selected]},on:{"update":_vm.update}})],1),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }